import { Box, Typography } from "@mui/material";

export const InvoiceHeaderClientView = ({ identifierId, issuedDate }: { identifierId: string; issuedDate: string }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: { xs: 1, sm: 2 } }}>
    <Box>
      <Typography variant="h3" fontWeight={900} sx={{ letterSpacing: "-0.033em", mb: 1, fontSize: { xs: "1.75rem", sm: "2.5rem" } }}>
        Create Invoice
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 0.5, sm: 1 }, color: "text.secondary", flexWrap: "wrap" }}>
        <Typography variant="body1" sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}>
          ID: {identifierId}
        </Typography>
        <Box sx={{ width: { xs: 3, sm: 4 }, height: { xs: 3, sm: 4 }, bgcolor: "grey.400", borderRadius: "50%" }} />
        <Typography variant="body1" sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}>
          Issued: {issuedDate}
        </Typography>
      </Box>
    </Box>
  </Box>
);
